import {
  CadastroCotasDeFundoApiRequest,
  CotasDeFundoApiResponse,
  NegociacaoSecundaria,
  TipoSerie,
  DocumentHistorico,
  TipoSerieHistorico,
  NegociacaoSecundariaHistorico,
  UploadDocumentos,
  TipoPagamento,
  type EventosFinanceiros,
  AmortizacaoSobre,
  CadastroInstrumentoFinanceiroApiRequest,
} from 'common/genericTypes';
import moment from 'moment';
import { CaracteristicasState } from 'store/modules/cotasDeFundo/caracteristicas';
import { State as Emissor } from 'store/modules/cotasDeFundo/emissor';
import { addCpfCnpjMask } from 'utils/mask';
import { isValid as isDateValid } from 'utils/date';

export default class CotasDeFundoParser {
  static stateToCadastroCotasDeFundoApiRequest(
    caracteristicas: CaracteristicasState
  ): CadastroCotasDeFundoApiRequest {
    const cotasDeFundo = {
      
      cnpjFundo: caracteristicas?.cnpjFundo ?? '',
      numeroEmissao: caracteristicas?.numeroEmissao ?? '',
      administradorFiduciarioId: caracteristicas?.administradorFiduciarioId ?? '',
      nomeFantasia: caracteristicas?.nomeFantasia ?? '',
      gestor: caracteristicas?.gestor ?? '',
      escrituradorId: caracteristicas?.escrituradorId ?? '',
      custodianteId: caracteristicas?.custodianteId ?? '',
      codigoAtivo: caracteristicas?.codigoAtivo ?? '',
      classe: caracteristicas?.classe ?? '',
      serie: caracteristicas?.serie ?? '',
      isin: caracteristicas?.isin ?? '',
      classificacaoANBIMA: caracteristicas?.classificacaoANBIMA ?? '',
      codigoANBIMA: caracteristicas?.codigoANBIMA ?? '',
      numeroAutorizacaoCVM: caracteristicas?.numeroAutorizacaoCVM ?? null,
      dataAutorizacaoCVM: caracteristicas?.dataAutorizacaoCVM ?? null,
      fundoExclusivo: caracteristicas?.fundoExclusivo ?? false,
      carencia: caracteristicas?.carencia ?? null,
      tipoFundo: caracteristicas?.tipoFundo ?? 'INEXISTENTE',
      casasDecimaisConversao: caracteristicas?.casasDecimaisConversao ?? null,
      criterioEspecificacaoCotas: caracteristicas?.criterioEspecificacaoCotas ?? '',
      especificacaoQuantidadeAutomatica: caracteristicas?.especificacaoQuantidadeAutomatica ?? false,
      custoCotista: caracteristicas?.custoCotista ?? 'COTISTA',
      confirmacaoOperacao: caracteristicas?.confirmacaoOperacao ?? 'EMISSOR',
      prazoCotacaoAplicacao: caracteristicas?.prazoCotacaoAplicacao ?? null,
      prazoCotacaoResgate: caracteristicas?.prazoCotacaoResgate ?? null,
      prazoLiquidacaoResgate: caracteristicas?.prazoLiquidacaoResgate ?? null,
      responsavelClassificacaoFundo: caracteristicas?.responsavelClassificacaoFundo ?? '',
      temPrevisaoPenalty: caracteristicas?.temPrevisaoPenalty ?? false,
      percentualPenalty: caracteristicas?.percentualPenalty ?? null,
      descricaoFundo: caracteristicas?.descricaoFundo ?? '',
    };
    
    return cotasDeFundo as unknown as CadastroCotasDeFundoApiRequest;
  }

  static apiResponseToCaracteristicasState(
    response: CotasDeFundoApiResponse
  ): CaracteristicasState {
    const caracteristicasState: CaracteristicasState = {

      cnpjFundo: response?.cnpjFundo ?? '',
      numeroEmissao: response?.numeroEmissao ?? '',
      administradorFiduciarioId: response?.administradorFiduciarioId ?? '',
      nomeFantasia: response?.nomeFantasia ?? '',
      gestor: response?.gestor ?? '',
      escrituradorId: response?.escrituradorId ?? '',
      custodianteId: response?.custodianteId ?? '',
      escriturador: '',
      custodiante: '',
      administradorFiduciario: response?.administradorFiduciario ?? '',
      codigoAtivo: '',
      classe: '',
      serie: '',
      isin: '',
      classificacaoANBIMA: '',
      codigoANBIMA: '',
      numeroAutorizacaoCVM: 0,
      dataAutorizacaoCVM: undefined,
      

      fundoExclusivo: response?.fundoExclusivo ?? false,
      carencia: response?.carencia ?? 0,
      tipoFundo: response?.tipoFundo || 'INEXISTENTE',
      casasDecimaisConversao: response?.casasDecimaisConversao ?? 0,
      criterioEspecificacaoCotas: response?.criterioEspecificacaoCotas ?? '',
      especificacaoQuantidadeAutomatica: response?.especificacaoQuantidadeAutomatica ?? false,
      custoCotista: response?.custoCotista ?? 'COTISTA',
      confirmacaoOperacao: response?.confirmacaoOperacao ?? 'EMISSOR',
      prazoCotacaoAplicacao: response?.prazoCotacaoAplicacao ?? 0,
      prazoCotacaoResgate: response?.prazoCotacaoResgate ?? 0,
      prazoLiquidacaoResgate: response?.prazoLiquidacaoResgate ?? 0,
      responsavelClassificacaoFundo: response?.responsavelClassificacaoFundo ?? '',
      temPrevisaoPenalty: response?.temPrevisaoPenalty ?? false,
      percentualPenalty: response?.percentualPenalty ?? 0,
      descricaoFundo: response?.descricaoFundo ?? '',
      

      dataAutorizacaoCVMUI: response?.dataAutorizacaoCVM ? moment(response.dataAutorizacaoCVM) : undefined,
      

      fundoExclusivoUI: response?.fundoExclusivo ? 
        { value: 'SIM', description: 'SIM' } : 
        { value: 'NÃO', description: 'NÃO' },
      tipoFundoUI: {
        value: response?.tipoFundo === 'outras opções' ? 'outras opções' : 'INEXISTENTE',
        description: response?.tipoFundo === 'outras opções' ? 'outras opções' : 'INEXISTENTE'
      },
      especificacaoQuantidadeAutomaticaUI: response?.especificacaoQuantidadeAutomatica ? 
        { value: 'SIM', description: 'SIM' } : 
        { value: 'NÃO', description: 'NÃO' },
      custoCotistaUI: {
        value: response?.custoCotista === 'outras opções' ? 'outras opções' : 'COTISTA',
        description: response?.custoCotista === 'outras opções' ? 'outras opções' : 'COTISTA'
      },
      confirmacaoOperacaoUI: {
        value: response?.confirmacaoOperacao === 'outras opções' ? 'outras opções' : 'EMISSOR',
        description: response?.confirmacaoOperacao === 'outras opções' ? 'outras opções' : 'EMISSOR'
      },
      temPrevisaoPenaltyUI: response?.temPrevisaoPenalty ? 
        { value: 'SIM', description: 'SIM' } : 
        { value: 'NÃO', description: 'NÃO' }
    };
    return caracteristicasState;
  }

}
